import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-3/4 mk-label text-gray-900 flex gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "w-6 flex-shrink-0"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmissionAnswers',
  props: {
    items: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key,
      class: _normalizeClass(["mt-5 pb-5 flex w-full", [
      __props.items.length > 1 ? 'border-b border-gray-200' : '',
      item?.answer?.length < 13 ? 'flex-row gap-6' : 'flex-col gap-3'
    ]])
    }, [
      _createElementVNode("dd", _hoisted_1, [
        (__props.items.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(key + 1) + ". ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, _toDisplayString(item.question), 1)
      ]),
      _createElementVNode("dd", {
        class: _normalizeClass(["mk-body text-gray-600 mr-2", [item?.answer?.length < 13 ? 'ml-auto' : '']])
      }, _toDisplayString(item.answer), 3)
    ], 2))
  }), 128))
}
}

})